import { useEffect, useState } from "react";
import { useParams, useSearchParams, Link } from "react-router-dom";
import { HeartHandshake, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Logo } from "@/components/Logo";
import { publicApi, errMsg } from "@/lib/api";

export default function PastoralResponse() {
  const { token } = useParams();
  const [params] = useSearchParams();
  const [info, setInfo] = useState(null);
  const [error, setError] = useState("");
  const [done, setDone] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { publicApi.get(`/public/pastoral-response/${token}`).then((r) => setInfo(r.data)).catch((e) => setError(errMsg(e))); }, [token]);
  const answer = async (a) => {
    setBusy(true);
    try { await publicApi.post(`/public/pastoral-response/${token}`, { answer: a }); setDone(a); } catch (e) { setError(errMsg(e)); } finally { setBusy(false); }
  };
  const suggested = params.get("answer");
  return (
    <div className="grid min-h-screen place-items-center bg-[#F8FAFC] px-5" data-testid="pastoral-response-page">
      <div className="w-full max-w-md rounded-3xl bg-white p-8 shadow-xl">
        <Link to="/"><Logo /></Link>
        <span className="mt-6 grid h-12 w-12 place-items-center rounded-2xl bg-[#EBF3FA] text-[#1D64B4]"><HeartHandshake className="h-6 w-6" /></span>
        {error && <p className="mt-4 text-slate-700" data-testid="pastoral-response-error">{error}</p>}
        {!error && !info && <Loader2 className="mt-4 h-6 w-6 animate-spin text-slate-400" />}
        {info && !done && (
          <>
            <h1 className="mt-4 text-2xl font-bold tracking-tight text-slate-900">Hi {info.name}, is this okay with you?</h1>
            <p className="mt-2 text-sm text-slate-600">For your <b>{info.service}</b> on {info.date} ({info.time}), we'd love for <b>{info.minister}</b> to minister.</p>
            <div className="mt-6 grid gap-2">
              <Button disabled={busy} onClick={() => answer("accept")} className={`rounded-full bg-[#0A3A6B] hover:bg-[#1D64B4] ${suggested === "accept" ? "ring-2 ring-[#1D64B4] ring-offset-2" : ""}`} data-testid="response-accept-button">Yes, that works for me</Button>
              <Button disabled={busy} variant="outline" onClick={() => answer("decline")} className={`rounded-full ${suggested === "decline" ? "ring-2 ring-slate-300 ring-offset-2" : ""}`} data-testid="response-decline-button">No, please call me</Button>
            </div>
          </>
        )}
        {done && (
          <div data-testid="pastoral-response-done">
            <h1 className="mt-4 text-2xl font-bold tracking-tight text-slate-900">Thank you!</h1>
            <p className="mt-2 text-sm text-slate-600">{done === "accept" ? "Your request is now confirmed. A confirmation email is on its way, and we'll send a reminder 3 days before." : "No problem. Our Pastoral Admin will call you to find what works best. God bless you!"}</p>
          </div>
        )}
      </div>
    </div>
  );
}
